import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { INCPCCPayment } from 'epay-library';
import { catchError, Observable, throwError } from 'rxjs';
import { NCPCashCreateBarcode } from 'src/app/features/common/models/NCP Cash Payments/ncp-cash-create-bardcode.model';
import { NCPCashListCases } from 'src/app/features/common/models/NCP Cash Payments/ncp-cash-list-cases.model';
import { NCPCashListOrder } from 'src/app/features/common/models/NCP Cash Payments/ncp-cash-list-order.model';
import { NCPCashValidateCaseOrder } from 'src/app/features/common/models/NCP Cash Payments/ncp-cash-validate-caseorder.model';
import { NCPCashValidatePayer } from 'src/app/features/common/models/NCP Cash Payments/ncp-cash-validate-payer.model';
import { SMIPayCCSessionToken } from 'src/app/features/common/models/SMI Pay- Credit Card/smi-pay-cc-session-token.model';
import { SMIPayRefreshToken } from 'src/app/features/common/models/SMI Pay- Credit Card/smi-pay-refresh-token.model';
import { SMIPayStatus } from 'src/app/features/common/models/SMI Pay- Credit Card/smi-pay-status.model';

@Injectable({
  providedIn: 'root'
})
export class EpayExtendedService {
  gateway = 'EPayGateway/EPay/api/v1/';

  httpOptions = {
    headers: new HttpHeaders(),
    params: new HttpParams(),
  };
  
  constructor(private http: HttpClient) { }

  ///////////////////////////////////////////
  ///////// NCP Cash Payment APIs //////////
  ///////////////////////////////////////////

  validateCashPayor(baseurl: string, payer: NCPCashValidatePayer): Observable<any> {
    const apiCmd = 'validatePayor';
    const gateway = 'EPayGateway/EPay/api/v1/Cash:';

    return this.http
      .post<any>(baseurl + gateway + apiCmd, payer)
      .pipe(catchError(this.handleError));
  }

  listCashCases(baseurl: string, participant: NCPCashListCases): Observable<any> {
    const apiCmd = 'listCases';
    const gateway = 'EPayGateway/EPay/api/v1/Cash:';

    return this.http
      .post<any>(baseurl + gateway + apiCmd, participant)
      .pipe(catchError(this.handleError));
  }

  listCashOrders(baseurl: string, participant: NCPCashListOrder): Observable<any> {
    const apiCmd = 'listOrder';
    const gateway = 'EPayGateway/EPay/api/v1/Cash:';

    return this.http
      .post<any>(baseurl + gateway + apiCmd, participant)
      .pipe(catchError(this.handleError));
  }

  validateCashCaseOrder(baseurl: string, participant: NCPCashValidateCaseOrder): Observable<any> {
    const apiCmd = 'validateCaseOrder';
    const gateway = 'EPayGateway/EPay/api/v1/Cash:';

    return this.http
      .post<any>(baseurl + gateway + apiCmd, participant)
      .pipe(catchError(this.handleError));
  }

  createCashPayBarcode(baseurl: string, participant: NCPCashCreateBarcode): Observable<any> {
    const apiCmd = 'createPaymentBarcode';
    const gateway = 'EPayGateway/EPay/api/v1/Cash:';

    return this.http
      .post<any>(baseurl + gateway + apiCmd, participant)
      .pipe(catchError(this.handleError));
  }

  ///////////////////////////////////////////
  //////// SMI PAY Credit Card APIs//////////
  ///////////////////////////////////////////

  insertNCPCreditCardAttempt(
    baseurl: string,
    ccPayment: INCPCCPayment
  ): Observable<any> {
    const apiCmd = 'createCreditCardPayment';
    const gateway = 'EPayGateway/EPay/api/v1/SMIPay/CreditCard:';
    this.resetHeader();

    return this.http
      .post<any>(baseurl + gateway + apiCmd, ccPayment)
      .pipe(catchError(this.handleError));
  }

  resetHeader() {
    this.httpOptions.headers = new HttpHeaders().set(
      'Content-Type',
      'application/json'
    );
  }


  getSMIPaySessionToken(baseurl: string, participant: SMIPayCCSessionToken): Observable<any> {
    const apiCmd = 'sessionToken';
    const gateway = 'EPayGateway/EPay/api/v1/SMIPay/CreditCard:';

    return this.http
      .post<any>(baseurl + gateway + apiCmd, participant)
      .pipe(catchError(this.handleError));
  }

  refreshSMIPaySessionToken(baseurl: string, participant: SMIPayRefreshToken): Observable<any> {
    const apiCmd = 'refreshSessionToken';
    const gateway = 'EPayGateway/EPay/api/v1/SMIPay/CreditCard:';

    return this.http
      .post<any>(baseurl + gateway + apiCmd, participant)
      .pipe(catchError(this.handleError));
  }

  // Get info for transaction on success page
  getSMIPayStatus(baseurl: string, participant: SMIPayStatus): Observable<any> {
      const apiCmd = 'status';
      const gateway = 'EPayGateway/EPay/api/v1/SMIPay/CreditCard:';
  
      return this.http
        .post<any>(baseurl + gateway + apiCmd, participant)
        .pipe(catchError(this.handleError));
  }


  private handleError(err: HttpErrorResponse) {
    let errorMessage = '';
    if (err.error instanceof ErrorEvent) {
      errorMessage = `An Error Occurred: ${err.error.message}`;
    } else if (err.status === 404 || err.status === 409) {
      return throwError(() => err);
    } else {
      errorMessage = `Server returned code: ${err.status}, error message is: ${err.message}`;
      console.log('Error Occurred: ' + errorMessage);
    }
    return throwError(() => err);
  }
}
